import { useState } from "react";
import { StoreFilterChip } from "./store-filter-chip";
import { StoreFilterDimension, StoreFilterDimensionId } from "./types";

interface StoreFilterChipsProps {
  dimensions: StoreFilterDimension[];
}

/**
 * Renderiza os chips de filtro a partir da configuração de dimensões e garante que
 * apenas um dropdown fique aberto por vez.
 */
export function StoreFilterChips({ dimensions }: StoreFilterChipsProps) {
  const [activeId, setActiveId] = useState<StoreFilterDimensionId | null>(null);

  return (
    <div className="relative z-20 flex flex-wrap items-center gap-2">
      {dimensions.map(dimension => (
        <StoreFilterChip
          key={dimension.id}
          label={dimension.label}
          summary={dimension.summary}
          options={dimension.options}
          isOpen={activeId === dimension.id}
          onToggleOpen={() =>
            setActiveId(prev => (prev === dimension.id ? null : dimension.id))
          }
          onClose={() => setActiveId(null)}
          onClear={dimension.onClear}
        />
      ))}
    </div>
  );
}
